import React from 'react';
import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import { Helmet } from 'react-helmet-async';
import { GridColDef, GridRenderCellParams, GridPaginationModel } from '@mui/x-data-grid';
import { Stack, Typography } from '@mui/material';
import { StatusArchive } from 'const/option';
import { capitalizeFirstLetter } from 'const/common';
import { useArchivePage } from './hook';
import { ActiveTab } from '../ControlPanelPage/ArchiveTab';

const HEADER_ARCHIVE: GridColDef[] = [
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    renderCell: (params: GridRenderCellParams) => {
      const status = params.row.status;
      const findStatus = StatusArchive.find((item) => item.value === status);
      return (
        <Stack alignItems="flex-start" justifyContent="center" height="100%">
          <Stack
            style={{
              background: findStatus?.color || '#686E7D',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 10px',
              height: '20px',
              borderRadius: '5px'
            }}>
            <Typography style={{ color: '#fff', fontSize: '10px', fontWeight: 600 }}>
              {capitalizeFirstLetter(findStatus?.label.replaceAll('_', ' ') || 'Close Seized')}
            </Typography>
          </Stack>
        </Stack>
      );
    }
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    width: 130,
    valueGetter: (_, row) => row.file?.firstName
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    width: 130,
    valueGetter: (_, row) => row.file?.lastName
  },
  { field: 'year', headerName: 'Year', width: 130, valueGetter: (_, row) => row.file.year },
  { field: 'make', headerName: 'Make', width: 130, valueGetter: (_, row) => row.file.make },
  { field: 'model', headerName: 'Model', width: 130, valueGetter: (_, row) => row.file.model },
  { field: 'vin', headerName: 'VIN', width: 130, valueGetter: (_, row) => row.file.vin },
  {
    field: 'fileNumber',
    headerName: 'File Number',
    width: 130,
    valueGetter: (_, row) => row.file.fileNumber
  },
  {
    field: 'client',
    headerName: 'Client',
    width: 150,
    valueGetter: (_, row) => row.file?.clientOption?.value
  },
  { field: 'plate', headerName: 'Plate', width: 130, valueGetter: (_, row) => row.file.plate }
];

export const ArchivePage = () => {
  const {
    rows,
    total,
    page,
    loading,
    handlePaginationModelChange,
    searchText,
    setSearchText,
    handleRowArchiveClick
  } = useArchivePage();

  return (
    <LayoutAdminTable onSearch={setSearchText} search={searchText} title="Archive">
      <Helmet>
        <title>Surrey Bailiffs - Archive</title>
      </Helmet>
      <ActiveTab
        handleRowClick={handleRowArchiveClick}
        header={HEADER_ARCHIVE}
        page={page}
        totalRows={total}
        handlePaginationModelChange={(newPaginationModel: GridPaginationModel) =>
          handlePaginationModelChange(newPaginationModel)
        }
        rows={rows}
        loading={loading}
      />
    </LayoutAdminTable>
  );
};
